import { DeleteButton, StandardButton } from "../atoms/buttons";
import { InputForm } from "../atoms/input";
import { TitleInput } from "./titleInput";
import { SettingHeader } from "../molecule/SettingHeader";
import { Alert } from "./alert";
import { MFAModal } from "./customModals";
import { useEffect, useState } from "react";
import { deleteAPI, fetchAPI, getAPI } from "../api/api";
import { icon } from "../functions/icons";
import { HorizontalLayout, VerticalLayout } from "./layout";
import { StandardComp } from "../atoms/standardComp";
import { SettingsHeader } from "../molecule/settingsHeader";
import { Modal, ModalBody, ModalTitle } from "./modal";

export function SecuritySetting({}) {
  const [MFAModalVisible, setMFAModalVisibility] = useState(false);
  const [deletionConfirmModalVisibility, setDeletionConfirmModalVisibility] = useState(false);
  const [authenticatorsList, setAuthenticatorsList] = useState([])

  async function loadMFA() {
    var authenticators = await getAPI("api/auth/mfa/authenticators");
    setAuthenticatorsList(authenticators.data)
  }
  useEffect(() => {loadMFA()}, [])

  async function disableMFA() {
    const response = await deleteAPI("api/auth/mfa/remove/all");
    if (response.success) {
      setAuthenticatorsList([]);
      loadMFA();
    }
    setDeletionConfirmModalVisibility(false);
  }

  return (
    <VerticalLayout className="settings-card">
      <SettingsHeader
        button={false}
        title="Beveiliging"
        description="Wachtwoorden en 2-staps verificatie"
      />
      <VerticalLayout className={"settings-comp"}>
      <div className="standard-padding standard-border standard-margin-bottom standard-rounded">
        <h6 className="regular-bold standard-text-color">
          Wachtwoord
        </h6>
        <p className="standard-margin-bottom light-bold standard-text-color-light">
          U kunt uw wachtwoord wijzigen door op de knop hieronder te klikken.
        </p>
        <Alert type="error" title={"U kunt uw wachtwoord hier niet wijzigen."} message={"U kunt op dit moment nog niet uw wachtwoord vanaf deze pagina wijzigen, druk op \"wachtwoord vergeten\" op de inlogpagina om dit te doen."}/>
        {/* <StandardButton style={{marginLeft: "0px"}} title={"Wachtwoord aanpassen"} /> */}
      </div>
      <div className="standard-padding standard-border standard-margin-bottom standard-rounded">
        <h6 className="regular-bold standard-text-color">
          2-staps verificatie
        </h6>
        <p className="standard-margin-bottom light-bold standard-text-color-light">
          Schakel 2-staps verificatie in om uw account te beveiligen. Dit voegt een extra laag beveiliging toe door een (tijdelijke) verificatiecode te vereisen naast uw wachtwoord tijdens het inlogproces. 
        </p>
        { authenticatorsList.length == 0 && <Alert type="info" title={"Beveilig je account"} message={"Door 2-staps verificatie in te schakelen maak je jouw account extra veilig."}/>}
        { authenticatorsList.length != 0 && <Alert title={"Ingeschakeld!"} message={"Goed bezig! 2-staps verificatie is ingeschakeld op uw account en biedt een extra laag van beveiliging!"}/>}
        <br/>
        <div className="mfa-authenticator-list">
          { authenticatorsList.map(function(v) {
            return <div key={v.mfa_id}>
              <HorizontalLayout className="mfa-authenticator-entry">
                <p style={{"flexGrow": 1}}>{v.name}</p>
                <span>{icon("trash")}</span>
              </HorizontalLayout>
            </div>
          })}
        </div>
        <MFAModal visible={MFAModalVisible} dismissedModal={() => setMFAModalVisibility(false)}/>
        <HorizontalLayout style={{"gap": "1rem"}}>
          <StandardButton style={{marginLeft: "0px"}} onClick={() => setMFAModalVisibility(true)} title={<>{icon("plus")}&nbsp;&nbsp;Toevoegen</>} />
          { authenticatorsList.length != 0 && <StandardButton backgroundColor="error-600" style={{marginLeft: "0px"}} onClick={() => setDeletionConfirmModalVisibility(true)} title={<>{icon("x")}&nbsp;&nbsp;Uitschakelen</>} />}
        </HorizontalLayout>
      </div>
      <div className="standard-padding standard-border standard-margin-bottom standard-rounded">
        <h6 className="regular-bold standard-text-color">
          Gevarenzone
        </h6>
        <p className="standard-margin-bottom light-bold standard-text-color-light">
          Heeft u uw account niet meer nodig? U kunt hem dan hier verwijderen. Let op! Dit is een omonkeerbare actie. U kunt uw account niet meer herstellen en alle gegevens gaan verloren.
        </p>
        <DeleteButton style={{marginLeft: "0px"}} title={"Account verwijderen"} />
      </div>
      </VerticalLayout>
      {/* <div className="horizontal space-between">
        <DeleteButton title={"Verwijder account"} />
        <StandardButton title={"Opslaan"} />
      </div> */}
      <Modal visible={deletionConfirmModalVisibility} dismissable={() => setDeletionConfirmModalVisibility(false)} content={
        <>
          <ModalTitle title="Weet je het zeker?" hasXmark={true} dismissable={() => setDeletionConfirmModalVisibility(false)}/>
          <ModalBody content={
            <>
              Door MFA uit te schakelen worden alle codes verwijderd, en zal de beveiliging van jouw account afnemen. Weet je het zeker?
              <HorizontalLayout style={{ justifyContent: "end", gap: "0rem", margin: "2rem 0px 0px 0px" }}>
                <StandardButton onClick={() => disableMFA()} backgroundColor="error-50" textColor="error-600" title="Ja, ik weet het zeker"/>
                <StandardButton onClick={() => setDeletionConfirmModalVisibility(false)} backgroundColor="primary-600" title="Annuleren"/>
              </HorizontalLayout>
            </>
          }/>
        </>
      }/>
    </VerticalLayout>
  );
}
